import { Dispatch } from '../../../types'
import { FetchActionCreator } from '../fetch/model'

export async function fetchLoaderHelper<T>(dispatch: Dispatch,
                                           actions: FetchActionCreator<T>,
                                           request: () => Promise<T>,
                                           onlyFetch?: boolean): Promise<T> {
  dispatch(actions.fetchStart())
  try {
    const resources: T = await request()
    dispatch(actions.fetchSuccess(onlyFetch ? undefined : resources))
    return Promise.resolve(resources)
  } catch (error) {
    dispatch(actions.fetchError(error, undefined))
    return Promise.reject(error)
  }
}
